
export const environment = {
    production: false,
    apiUrl: '#{apiUrl}#',
    signalRurl: '#{signalRurl}#',
    sourceName: 'SARAPLUS SecureData QA',
    tokenCredentials: '#{tokenCredentials}#',
    sessionDecryptKey: '#{sessionDecryptKey}#',
    ignoreEncryption: true,
    azureFDID: '6b3c6079-782d-4ffa-95e7-6c0f459b0083',
    sessionTimeout: '#{sessionTimeout}#',
    sessionIdle: '#{sessionIdle}#',
    appVersion: '#{buildVersion}#',
    smartyApiKey: '4149485524500617',
    smartyApiUrl: 'https://us-autocomplete-pro.api.smarty.com',
    sentryTokenUrl: '#{secureDataSentryTokenUrl}#'
}